import { useSelector } from 'react-redux';
import { getContentByContentType } from '../../cms/cms-reducer';
import { getSortedCampaignObjects } from '../../utils/cms-utils';

import styles from './campaign-banner.module.less';
import { Campaign } from './Campaign';
import { CMS_CONTENT_TYPE_CAMPAIGN } from './CampaignConstants';

const SearchCampaignBanner = () => {
    const campaignContent = useSelector((state) =>
        getContentByContentType({ state, contentType: CMS_CONTENT_TYPE_CAMPAIGN })
    );
    const campaigns = getSortedCampaignObjects(campaignContent);
    const numberOfCampaigns = campaigns?.length;

    if (!campaigns || numberOfCampaigns === 0) {
        return null;
    }

    return (
        <div className={styles.searchBannerContainer}>
            {campaigns.map((campaign) => (
                <Campaign
                    key={campaign.title}
                    name={campaign.title}
                    image={campaign.image}
                    link={campaign.linkToCampaign}
                    trackingLocation={'search'}
                />
            ))}
        </div>
    );
};

export default SearchCampaignBanner;
